import { render, staticRenderFns } from "./VModalSellGallina.vue?vue&type=template&id=a64ba2ae&scoped=true&"
import script from "./VModalSellGallina.vue?vue&type=script&lang=js&"
export * from "./VModalSellGallina.vue?vue&type=script&lang=js&"
import style0 from "./VModalSellGallina.vue?vue&type=style&index=0&id=a64ba2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64ba2ae",
  null
  
)

export default component.exports